import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttributeModel, Lang, ReferenceParams, Res } from 'src/app/models';
import { ApiAttributesValidatorService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { AttributesValidatorsActionsValidator } from './attributes-validators.validator';

@Component({
  selector: 'app-attributes-validators-actions',
  templateUrl: './attributes-validators-actions.component.html',
  styleUrls: ['./attributes-validators-actions.component.css']
})
export class AttributesValidatorsActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  validatorId: string;
  language: string;
  loading: boolean;
  errorMessages: any;
  validatorName: Lang;
  attributes: AttributeModel[] = [];
  operators: any[] = [];
  condition = {};
  selectedOperatorsForCondition: string = 'AND';
  operatorsForCondition = [
    {
      id: 'AND',
      name: 'И'
    },
    {
      id: 'OR',
      name: 'ИЛИ'
    }
  ]

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null, this.validator.name]
  });

  conditionForm: UntypedFormGroup = this.fb.group({
    filters: this.fb.array([])
  })

  @Input() set data(value) {

    if (value != null) {

      this.validatorId = value.attr_id;

    }
  }


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiValidatorService: ApiAttributesValidatorService,
    public activeModal: NgbActiveModal,
    private notification: NotificationService,
    private validator: AttributesValidatorsActionsValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
    this.getAttributes();
    this.getOperatoprs();

    if (this.validatorId) {

      this.form.controls.id.setValue(this.validatorId);
      this.onEdit();

    } else {

      this.addFilterFields();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }

  /**
   * 
   * 
   */
  addFilterFields(): void {

    let control = this.conditionForm.controls.filters as UntypedFormArray;
    control.push(this.initFilterField());
  }


  /**
  * 
  * 
  */
  initFilterField(): any {

    return this.fb.group({
      attribute_id: [null, this.validator.attribute_id],
      operator: ['equal', this.validator.operator],
      value: [null, this.validator.value],
    });
  }


  /**
  * 
  * @param i number
  */
  removeAddressField(i: number): void {

    let control = this.conditionForm.controls.filters as UntypedFormArray;
    control.removeAt(i);
  }


  /**
   * 
   */
  resetFilter() {
    this.form.reset();
    // this.condition[this.selectedOperatorsForCondition] = [];
  }

  /**
  * 
  */
  getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        type: ['INPUT', 'TEXTAREA']
      }
    }

    this.subscriptions.add(
      this.apiValidatorService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRS: ", response);


        if (response != null) {

          this.attributes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getOperatoprs(): void {

    let params: ReferenceParams = {
      ref_name: 'filter_conditions_operators',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiValidatorService.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("DATA: ", response);


        if (response != null) {

          this.operators = response.result;
        }
      })
    );

  }

  /**
   * 
   * @param address Address
   */
  setDataInValidatorField(validator: any): any {

    console.log("SET DATA: ", validator);


    return this.fb.group({
      attribute_id: validator.attribute_id,
      operator: validator.operator,
      value: [validator.value]
    });
  }


  /**
   * 
   * @param address Address
   */
  addValidatorFieldWithData(validator: any): void {

    let control = this.conditionForm.controls.filters as UntypedFormArray;
    control.push(this.setDataInValidatorField(validator));
  }


  /**
  * 
  */
  onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiValidatorService.edit(this.validatorId).subscribe((response: Res) => {
        console.log('[RESPONSE] VALIDATOR_EDIT: ', response);

        if (response != null) {

          this.validatorName = response.result.name;
          this.selectedOperatorsForCondition = Object.keys(response.result.conditions).toString();

          if (Object.keys(response.result.conditions).length > 0) {

            for (let obj of response.result.conditions[Object.keys(response.result.conditions)[0]]) {

              this.addValidatorFieldWithData(obj);

            }

          }

          console.log(this.condition);

        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**
   * 
   */
  onCreate(): void {

    this.selectedOperatorsForCondition == 'AND' ? this.condition = { AND: [] } : this.condition = { OR: [] };

    let form = { ...this.form.value }


    for (let c of this.conditionForm.value.filters) {

      if (!c.value) break;

      this.condition[this.selectedOperatorsForCondition].push({
        attribute_id: c.attribute_id,
        operator: c.operator,
        value: c.value.map(val => val.value)
      });
    }



    form['conditions'] = this.condition[this.selectedOperatorsForCondition].length > 0 ? this.condition : {};

    this.progressRef.start();

    console.log("FORM: ", form);


    this.subscriptions.add(
      this.apiValidatorService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] createValidator: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   */
  onUpdate(): void {

    this.selectedOperatorsForCondition == 'AND' ? this.condition = { AND: [] } : this.condition = { OR: [] };

    let form = { ...this.form.value }


    for (let c of this.conditionForm.value.filters) {

      if (!c.value) break;

      this.condition[this.selectedOperatorsForCondition].push({
        attribute_id: c.attribute_id,
        operator: c.operator,
        value: c.value
      });
    }



    form['conditions'] = this.condition[this.selectedOperatorsForCondition].length > 0 ? this.condition : {};

    this.progressRef.start();

    console.log("FORM: ", form);


    this.subscriptions.add(
      this.apiValidatorService.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] createValidator: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.conditionForm.get(field), type);
  }

}
